import { ApiGroup } from '../types/ApiTypes';

export const DeviceAPI: ApiGroup = {
    pagedList: {
        title: '디바이스 목록 조회',
        method: 'POST',
        url: '/Device/PagedList',
        paramz: {},
    },
    getByUserId: {
        title: '사용자 디바이스 조회',
        method: 'GET',
        url: '/Device/User/:userId',
        paramz: {},
    },
};
